<div class="main-card mb-3 card">
  <div class="card-header font-weight-B fs-1r">Package Configuration</div>
  <div class="tab-content" id="nav-tabContent">
    <div class="justify-content-center align-items-center min-vh-75 m-5">
      <table class="table table-bordered w-50 mx-auto">
        <thead>
          <tr class="text-center">
            <th scope="col">Configuration Items</th>

            <th scope="col">
              Amounts ( <i class="fa fa-inr"></i> ) / GST ( % )
            </th>
          </tr>
        </thead>
        <tbody>
    
          <tr>
            <td>Helper Amount</td>
            <td><i class="fa fa-inr"></i> {{ helperAmount }}</td>
          </tr>
          <tr>
            <td>Convenience Fee</td>
            <td><i class="fa fa-inr"></i> {{ convenience }}</td>
          </tr>
          <tr>
            <td>Coupon Amount</td>
            <td><i class="fa fa-inr"></i> {{ couponAmount }}</td>
          </tr>
          <tr>
            <td>Commission Per Trip</td>
            <td><i class="fa fa-inr"></i> {{ commission }}</td>
          </tr>
          <tr>
            <td>Trip Fare GST</td>
            <td>{{ tripFareGST }}%</td>
          </tr>
          <tr>
            <td>Helper GST</td>
            <td>{{ helperGST }}%</td>
          </tr>
          <tr>
            <td>Commission Fee GST</td>
            <td>{{ commissionGST }}%</td>
          </tr>
          <tr>
            <td>Convenience Fee GST</td>
            <td>{{ convenienceGST }}%</td>
          </tr>
          <tr>
            <td>Helper TDS Percent</td>
            <td>{{ helperTDSPercent }}%</td>
          </tr>
          <tr>
            <td>Distance for Trip Notification</td>
            <td>{{ distanceForTripNotification }}KM</td>
          </tr>
          <tr>
            <td>Mininmum Distance For Trip</td>
            <td>{{ minimumDistanceForTrip }}KM</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <button
          class="w-25 btn btn-primary"
          (click)="editPackageConfig(editPkgConfig)"
        >
          Edit Configuration
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update Model -->
<div class="card-body">
  <ng-template #editPkgConfig let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil"> Edit Package Configuration</i>
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body align-items-center">
      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Helper Amount <span>( <i class="fa fa-inr"></i> )</span> :
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperAmount"
            class="form-control"
            placeholder="Helper Amount"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Helper GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperGST"
            class="form-control"
            placeholder="Helper GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Coupon Basic Amount <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="couponAmount"
            class="form-control"
            placeholder="Coupon Basic Amount"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Trip Fare GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="tripFareGST"
            class="form-control"
            placeholder="Trip Fare GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Commission Fee <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="commission"
            placeholder="Commission Fee"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Commission Fee GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="commissionGST"
            class="form-control"
            placeholder="Commission Fee GST"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Convenience Fee <span>( <i class="fa fa-inr"></i> )</span>:
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="convenience"
            placeholder="Convenience Fee"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Convenience Fee GST (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="convenienceGST"
            class="form-control"
            placeholder="Commission Fee GST"
          />
        </div>
        <div class="col-md-6"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Min Distance For Trip( <span class="font-weight-B">KM</span> ):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="minimumDistanceForTrip"
            placeholder="Minimum Distance For Trip (KM)"
            class="form-control"
          />
        </div>
        <div class="col-md-5">
          <label for=""
            >Helper TDS (<span class="font-weight-B">%</span>):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="helperTDSPercent"
            class="form-control"
            placeholder="Helper TDS"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-5">
          <label for=""
            >Notification Distance ( <span class="font-weight-B">KM</span> ):
          </label>
          <input
            type="number"
            min="0"
            [(ngModel)]="distanceForTripNotification"
            class="form-control"
            placeholder="Distance for Notification (KM)"
          />
        </div>

        <div class="col-md-2"></div>
      </div>
      <div class="align-items-center text-center">
        <button
          class="btn btn-primary col-md-10 mt-3"
          (click)="updatePackageConfig()"
          [disabled]="
            helperAmount === null ||
            helperAmount === undefined ||
            helperTDSPercent === null ||
            helperTDSPercent === undefined ||
            helperGST === null ||
            helperGST === undefined ||
            couponAmount === null ||
            couponAmount === undefined ||
            tripFareGST === null ||
            tripFareGST === undefined ||
            commission === null ||
            commission === undefined ||
            commissionGST === null ||
            commissionGST === undefined ||
            convenience === null ||
            convenience === undefined ||
            convenienceGST === null ||
            convenienceGST === undefined ||
            minimumDistanceForTrip === null ||
            minimumDistanceForTrip === undefined ||
            distanceForTripNotification === null ||
            distanceForTripNotification === undefined
          "
        >
          Update
        </button>
      </div>
    </div>
  </ng-template>
</div>
